/**
 * Drawer names that can be sources of UI Context for scan events.
 */
export const DRAWER_NAMES = {
  LABEL_PURCHASED_DRAWER: 'label_purchased_drawer',
  LABEL_PURCHASING_DRAWER: 'label_purchasing_drawer',
  ORDER_DETAILS: 'order_details',
  SHIPMENT_DETAILS: 'shipment_details',
} as const;
